import api from "../api/axios";
import userStore from "../store/userStore";
import { getBaseUrl } from "../utils/getBaseUrl";
import getCurrentEnv from "../utils/getCurrentEnv";
import { getDefinedValues } from "../utils/getDefinedValues";

const buildPayload = (eventName, properties = {}) => {
  const userState = userStore.getState();
  const { page, action, reportName, merchantName, ...extra } = properties;

  return {
    eventName,
    userId: userState.userId || null,
    timestamp: new Date().toISOString(),
    sessionId: userState.sessionId || null,
    properties: {
      page: page || null,
      action: action || null,
      reportName: reportName || null,
      merchantName: merchantName || null,
      ...extra,
    },
  };
};

const sendEventLog = async (payload) => {
  const env = getCurrentEnv();

  try {
    await api.post(`${getBaseUrl(env)}/api/analytics/events`, payload);
  } catch (err) {
    console.log("Failed to send event log ", err);
  }
};

const Logger = {
  log(eventName, properties = {}) {
    const payload = getDefinedValues(buildPayload(eventName, properties));
    sendEventLog(payload);
    return payload;
  },
};

export default Logger;
